export const isMultistepQuiz = () => {
  return localStorage.getItem('isMultiStepQuiz') === 'true'
}
